
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { CopiarAlPortapapeles } from '@/__env/ext';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Envio() { return this.Controlador.Pedido ? this.Controlador.Pedido.Envio : null; }
        public Estado: string = 'cargando';
        public Link: string = '';


        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = true; } );
        }

        public Seguimiento: string = '';
        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        async onAbierto()
        {
            if ( this.Abierto )
            {
                this.Estado = 'cargando';
                this.Seguimiento = await this.Envio.cargarSeguimiento();
                this.Estado = this.Seguimiento ? 'ok' : 'error';
                if ( this.Estado == 'ok' && this.Envio.EmpresaLogistica.esCorreoArgentino )
                    this.Link = `https://www.correoargentino.com.ar/empresas/tyt/service.php?id=${this.Envio.Tracking.Codigo}&cliente=16276000`;
                else if ( this.Estado == 'ok' && this.Envio.EmpresaLogistica.esOCA )
                    this.Link = `http://www1.oca.com.ar/OEPTrackingWeb/detalleenviore.asp?numero=${this.Envio.Tracking.Codigo}`;
                else
                    this.Link = '';
            }
        }

        Copiar()
        {
            CopiarAlPortapapeles( this.Link );
            Utiles.Notificaciones.Completado( 'Copiado!' );
        }
    }
